module.exports = __webpack_public_path__ + "img/79ne.6e71ae3d.svg";